<template>
    <v-container>
        <router-link :to="{name: 'systemslist'}">&lt;&lt;Back to Infrastructure List</router-link>
        <p></p>
         <v-layout wrap>
            <v-flex>
                <h3>{{system.type ? system.type.description : system.code}}: {{system.name}}</h3>
            </v-flex>
            <v-flex>
                <v-switch inset v-if="!!system.id" :input-value="system.pollEnabled" :loading="enabling" :disabled="enabling" :label="enabledLabel()" v-on:click.stop="toggleEnabled(system)" hide-details></v-switch>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex ma-2 pa-2 >
                <system-data-entry-section v-if="appSection" :system="system" :section="appSection"
                    :display="true" :displaySystemInfo="true" @systemdirty="systemdirty"
                    :userIsSU="isSU" :userIsSUPro="isSUPro" :sections="sections" 
                    @sectionPropChanged="sectionPropChanged" :sectionIdChanged="sectionIdChanged">
                </system-data-entry-section>
            </v-flex>
        </v-layout>
        <v-layout v-for="(section) in nonAppSections" :key="section.id">
            <v-flex ma-2 pa-2 v-if="showSection(section)">
                <system-data-entry-section :system="system" :section="section" 
                :sections="allSections" @systemdirty="systemdirty" :userIsSU="isSU" :userIsSUPro="isSUPro" 
                    @sectionPropChanged="sectionPropChanged" :sectionIdChanged="sectionIdChanged"></system-data-entry-section>
            </v-flex>
        </v-layout>
        <v-layout v-if="orgLevelSections">
            <v-layout v-for="(section) in orgLevelSections" :key="section.id">
                <v-flex ma-2 pa-2 v-if="showSection(section)">
                    <system-data-entry-section :section="section" :sections="allSections" 
                    :orgLevel="true" :userIsSU="isSU" :userIsSUPro="isSUPro" 
                    @sectionPropChanged="sectionPropChanged" :sectionIdChanged="sectionIdChanged">
                    </system-data-entry-section>
                </v-flex>
            </v-layout>
        </v-layout>
        <v-layout v-if="showSchedules()" ma-2 pa-2>
            <v-flex>
                <system-schedules :system="system" :schedules="schedules" :disableInterval="!isSUPro"></system-schedules>
            </v-flex>
        </v-layout>
        <v-layout v-if="this.system.id && (isSU || isSUPro)">
            <v-flex xs6 ml-4>
                <v-select :items="getCollectionAgents(system)" v-model="system.ccaId"
                label="Collection Agents"
                    item-text="login" item-value="id"></v-select>
            </v-flex>
            <v-flex xs1 mt-3>
                <v-btn text small @click="saveCcaId">Save</v-btn>
            </v-flex>
            <v-flex xs1 mt-3>
                <v-btn text small @click="resetCcaId">Reset</v-btn>
            </v-flex>
        </v-layout>
        <v-dialog
                v-model="enabling"
                persistent
                width="300"
                >
                <v-card
                    color="primary"
                    dark
                >
                    <v-card-text>
                    Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                    </v-card-text>
                </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SystemInfo from './SystemInfo.vue'
import SystemDataEntrySection from './SystemDataEntrySection.vue'
import SystemSchedules from './SystemSchedules.vue'
import _ from 'lodash'
export default {
    data(){
        return {
            enabling: false,
            sectionIdChanged: null
        }
    },
    components: {
      'system-info': SystemInfo,
      'system-data-entry-section': SystemDataEntrySection,
      'system-schedules': SystemSchedules
    },
    computed: {
        ...mapState('systems', {
            system: state => state.activeSystem
        }),
        ...mapGetters('systems', {
            sections: 'activeSystemDataEntrySections',
            appSection: 'activeSystemAppSection',
            nonAppSections: 'activeSystemNonAppSections',
            schedules: 'activeSystemDocumentSchedules',
            orgLevelSections: 'activeSystemOrgLevelConfigs'
        }),
        ...mapGetters('user', {
            userRoles: 'roles',
            isProfessional: 'isProfessional',
            isSU: 'isSU',
            isSUPro: 'isSUPro',
            caUsers: 'getCollectionAgents',
            ccoUsers: 'getCcoUsers'
        }),
        allSections: {
            get() {
                return _.concat(this.sections, this.orgLevelSections)
            }
        }
    },
    mounted() {
        if (_.isUndefined(this.$route.params.id) && _.isEmpty(this.system)) {
            this.$router.replace({name: 'systemslist'})
        }
    },
    methods: {
        async systemdirty() {
            await this.$store.dispatch("systems/getSystem", this.system.id || this.$route.params.id);
        },
        showSchedules() {
            if (!this.system.id) {
                return false
            }
            if (_.isEmpty(this.userRoles)) {
                return true
            }

            return this.isSU
        },
        showSection(section) {
            if (!section) {
                return false
            }
            if (!this.system.id) {
                return section.id === 'app'
            }
            
            if (section.visible && section.visible.startsWith('eval:')) {
                return eval(section.visible.substring(5))
            }
            let sectionRoles = section.roles
            if (!sectionRoles || (sectionRoles === 'all') || _.isEmpty(this.userRoles)) {
                return true
            }

            let tokens = sectionRoles.split(',')

            let intersection = _.intersection(tokens, this.userRoles)

            return !_.isEmpty(intersection)
        },
        async toggleEnabled(system) {
            if (system.pollEnabled) {

                if (system.isOAuth) {
                    if (!confirm("Disabling this system will remove any OAuth integrations that will not be recovered upon enabling this system again. Do you wish to continue disabling?")) {
                        return
                    }
                }

                var result = await this.$store.dispatch('systems/toggleEnabled', system)
                if (system.isOAuth && !system.pollEnabled && !!result) {
                    this.systemdirty()
                }
            } else {
                this.enabling = true
                let validationResult = await this.$store.dispatch("systems/validateActiveSystem")
                if ((validationResult && validationResult.success) || (confirm('The system could not be validated. ' +  (validationResult.message ? ('(' + validationResult.message + ')') : '') + ' Do you wish to continue enabling it?'))) {
                    await this.$store.dispatch('systems/toggleEnabled', system)
                }
                this.enabling = false
            }
        },
        enabledLabel() {
            return this.system.pollEnabled ? "Enabled" : "Disabled"
        },
        getCollectionAgents(system) {
            if (system.isCloudSystem) {
                var regex = new RegExp('\\b' + system.code + '\\b', 'i')
                var relevantUsers = _.filter(this.ccoUsers, (user) => { 
                    return regex.test(user.login) // || user.login.toLowerCase().includes('default') 
                })
                return _.concat({login: '<default service account>', id: null}, this.caUsers, relevantUsers)
            }
            return _.concat({login: '<default service account>', id: null}, this.caUsers)
        },
        async saveCcaId() {

            var message = !this.system.ccaId ? 'Do you wish to un-assign ' + this.system.name + ' from its current ' +
            'collection agent? It will be collected using the default service account' :
            'Do you wish to assign ' + this.system.name + ' to the selected collection agent? It will no longer ' +
            'be collected using the default service account.'

        if (confirm(message)) {
            await this.$store.dispatch('systems/saveActiveSystemCcaId')
            }
        },
        resetCcaId() {
            this.$store.dispatch("systems/resetActiveSystemCcaId")
        },
        sectionPropChanged({sectionId, prop}) {
            if (this.sectionIdChanged !== sectionId) {
                this.sectionIdChanged = sectionId
            }
            setTimeout(() => {
                this.sectionIdChanged = null
            }, 0);
        }
    }
};
</script>